export default __webpack_public_path__ + "fonts/79effff826bfc9bcfccdd714d64a6578.woff2";